<template lang="pug">
button(type="button" @click="handleClick" :disabled="loading" :class="css")
  span(v-if="!loading") {{ text }} &nbsp;
  i(v-if="icon !== '' && !loading" :class="icon")
  .spinner-grow.spinner-grow-sm.text-white(v-if="loading")
</template>

<script>
export default {
  name: 'SpinButton',
  props: {
    text: {
      type: String,
      default: 'OK'
    },
    css: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
button {
  display: flex;
  align-items: center;
  justify-content: center !important;
}
</style>
